<div class="info-item" [class.info-item-red]="color === 'red'">
  <div class="info-label">
    <ng-container> {{ label | translate }}: </ng-container>
  </div>
  <div class="info-value">
    <ng-container>{{ value }}</ng-container>
    <ng-content></ng-content>
  </div>
</div>
